import { combineReducers } from '@reduxjs/toolkit';
import archiveOrganizationReducer from './archive-organization';
import createChildOrganizationReducer from './create-child-organization';
import createClientOrganizationReducer from './create-client-organization';
import createOrganizationReducer from './create-organization';
import deleteOrganizationReducer from './delete-organization';
import getChildOrganizationListReducer from './get-child-organization-list';
import getClientOrganizationReducer from './get-client-organization';
import getClientOrganizationListReducer from './get-client-organization-list';
import getMyOrganizationReducer from './get-my-organization';
import getOrganizationReducer from './get-organization';
import getOrganizationListReducer from './get-organization-list';
import get_organization_worker_list__reducer from './get-organization-worker-list-';
import getParentHierarchyReducer from './get-parent-hierarchy';
import getSubjectsOrganizationLevelsReducer from './get-subjects-organization-levels';
import sendSlaEmailReducer from './send-sla-email';
import toggleClientOrganizationActivationReducer from './toggle-client-organization-activation';
import toggleRequireSlaAgreementReducer from './toggle-require-sla-agreement';
import unarchiveOrganizationReducer from './unarchive-organization';
import updateChildOrganizationReducer from './update-child-organization';
import updateClientOrganizationReducer from './update-client-organization';
import updateMyOrganizationReducer from './update-my-organization';
import updateOrganizationReducer from './update-organization';

const organizationReducer = combineReducers({
  archiveOrganization: archiveOrganizationReducer,
  createChildOrganization: createChildOrganizationReducer,
  createClientOrganization: createClientOrganizationReducer,
  createOrganization: createOrganizationReducer,
  deleteOrganization: deleteOrganizationReducer,
  getChildOrganizationList: getChildOrganizationListReducer,
  getClientOrganization: getClientOrganizationReducer,
  getClientOrganizationList: getClientOrganizationListReducer,
  getMyOrganization: getMyOrganizationReducer,
  getOrganization: getOrganizationReducer,
  getOrganizationList: getOrganizationListReducer,
  get_organization_worker_list_: get_organization_worker_list__reducer,
  getParentHierarchy: getParentHierarchyReducer,
  getSubjectsOrganizationLevels: getSubjectsOrganizationLevelsReducer,
  sendSlaEmail: sendSlaEmailReducer,
  toggleClientOrganizationActivation:
  toggleClientOrganizationActivationReducer,
  toggleRequireSlaAgreement: toggleRequireSlaAgreementReducer,
  unarchiveOrganization: unarchiveOrganizationReducer,
  updateChildOrganization: updateChildOrganizationReducer,
  updateClientOrganization: updateClientOrganizationReducer,
  updateMyOrganization: updateMyOrganizationReducer,
  updateOrganization: updateOrganizationReducer
});

export default organizationReducer;